import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dashboard } from './Dashboard';
import { authStore } from '../api/client';

/**
 * SessionPage
 *
 * Route: /session/:sessionId
 *
 * Thin auth guard around Dashboard.
 * Dashboard now calls useParams() directly and handles all data fetching
 * and WebSocket management itself - SessionPage only blocks unauthenticated access.
 */
export default function SessionPage() {
  const navigate = useNavigate();

  // Guard: an access token must be present (set by login / register).
  // ProtectedRoute already covers this, but keep a defensive check for direct mounts.
  if (!authStore.accessToken) {
    console.warn('[SessionPage] No accessToken in authStore - blocking access to Dashboard');
    return (
      <div className="flex items-center justify-center py-24 px-6">
        <div className="text-center space-y-4 max-w-sm">
          <div className="text-4xl" aria-hidden="true">🔒</div>
          <h2 className="text-xl font-semibold text-slate-900">Session credentials not found</h2>
          <p className="text-slate-500 text-sm">
            This page was opened in a new tab or the browser was refreshed.
            Please go back to the dashboard and create or resume a session.
          </p>
          <button
            onClick={() => navigate('/dashboard')}
            className="btn btn-md btn-primary"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return <Dashboard />;
}
